import React from 'react';
import ContactTitle, {CTTitle} from "./ContactTitle";
import service_item_cs_bg2 from "../images/service-item-cs-bg2.png";
import service_icon from "../images/service-icon.png";
import "./CSService.css"

const classNames = require('classnames');

export function CSServiceItem(props: {
    children: JSX.Element | Array<JSX.Element> | string
    className1?: string
    className2?: string
    className?: string
}) {
    return (
        <div className={classNames(props.className, props.className1)}>
            <div className={classNames('service-item-cs-bg', props.className2)}>
                <img className='service-item-cs-sharp' src={service_item_cs_bg2} alt='service-item-cs-sharp'/>
            </div>
            <p className='service-item-cs-text'>
                {props.children}
            </p>
        </div>
    )
}

export default function CSService() {

    return (
        <div className='service-cs'>
            <ContactTitle src={service_icon}>
                <CTTitle>
                    在线技术服务
                </CTTitle>
            </ContactTitle>
            <div className='service-contents'>
                <CSServiceItem
                    className={'service-item-cs'}
                    className1={'service-item-1-1'}
                    className2={'service-item-1-2'}
                >
                    技术支持1
                </CSServiceItem>
                <CSServiceItem
                    className={'service-item-cs-2'}
                    className1={'service-item-2-1'}
                    className2={'service-item-2-2'}
                >
                    技术支持2
                </CSServiceItem>
                <CSServiceItem
                    className={'service-item-cs-3'}
                    className1={'service-item-3-1'}
                    className2={'service-item-3-2'}
                >
                    技术支持3
                </CSServiceItem>
                <CSServiceItem
                    className={'service-item-cs-4'}
                    className1={'service-item-4-1'}
                    className2={'service-item-4-2'}
                >
                    技术支持4
                </CSServiceItem>
            </div>
        </div>
    )
}